import { render } from "./UserAvatar.vue?vue&type=template&id=36bbf795&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=36bbf795&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36bbf795"

export default script